export default "__VITE_ASSET__MzqvOovG__"